import { ReactNode } from 'react'

type BadgeVariant = 'default' | 'success' | 'warning' | 'error' | 'info'

interface BadgeProps {
  variant?: BadgeVariant
  children: ReactNode
  dot?: boolean
}

export function Badge({ variant = 'default', children, dot = false }: BadgeProps) {
  return (
    <>
      <span className={`badge badge--${variant}`}>
        {dot && <span className="badge-dot" />}
        {children}
      </span>

      <style>{`
        .badge {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          padding: 2px 8px;
          border-radius: 99px;
          font-size: 0.72rem;
          font-weight: 600;
          letter-spacing: 0.03em;
          white-space: nowrap;
        }
        .badge--default { background: var(--bg-hover); color: var(--text-secondary); }
        .badge--success { background: var(--bg-success); color: var(--color-success); }
        .badge--warning { background: var(--bg-warning); color: var(--color-warning); }
        .badge--error   { background: var(--bg-error);   color: var(--color-error); }
        .badge--info    { background: var(--bg-info);    color: var(--color-info); }
        .badge-dot {
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: currentColor;
          flex-shrink: 0;
        }
      `}</style>
    </>
  )
}
